import { createGtm, useGtm } from '@gtm-support/vue-gtm';
import log from '~/utils/log';

export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter();
    const runtimeConfig = useRuntimeConfig();
    const nonce = useNonce();

    nuxtApp.vueApp.use(
        createGtm({
            id: runtimeConfig.public.googleTagManager.id,
            defer: true,
            nonce: nonce,
            loadScript: true,
            vueRouter: router,
            enabled: false // We have to manually control GTM to prevent all and any request or cookies from GTM/GA4.
        })
    );

    const gtmConsent = useUsercentricsConsentItem('google_tag_manager');
    const gaConsent = useUsercentricsConsentItem('google_analytics');
    const gtm = useGtm();

    const applyConsent = () => {
        if (!gtm) return;

        if (gtmConsent.value !== true || gaConsent.value !== true) {
            gtm.enable(false);
            return;
        }

        gtm.enable(true);
    };

    refreshUsercentricsConsentCache()
        .then(applyConsent)
        .catch((error) => {
            log.warn('Failed to refresh Usercentrics consent state', error);
        });
    onConsentUpdated(applyConsent);
});
